export default __webpack_public_path__ + "static/media/people-1.fb44e00f.jpg";